module.exports = __webpack_public_path__ + "img/go.dc84bfdc.svg";